import React, { useState, useEffect } from "react";
import logo from "../images/G3Logo.jpg";
import adGoOurHub from "../images/ad_goourhub.jpg"; // <-- import your ad image
import "./VaduAplu.css";

const images = [
  require("../images/g31.png"),
  require("../images/g32.jpg"),
  require("../images/g33.jpg"),
  require("../images/g34.jpg"),
  require("../images/g35.jpg"),
  require("../images/g36.jpg"),
];


function G3Production() {
  const [dealIndex, setDealIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const deals = [
    "Get 10% on services when you mention GOOURHUB",
    "Mention GoOurHub to get better price/discounts",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setDealIndex((prev) => (prev + 1) % deals.length);
        setFade(true);
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="vaduaplu-container">
      {/* Header */}
      <header className="vaduaplu-header">
        {/* Left: Logo + Name */}
        <div className="vaduaplu-header-left">
          <img src={logo} alt="Logo" className="vaduaplu-logo" />
          <div className="vaduaplu-header-text">
            <h1 className="vaduaplu-company-name"> G3 Productions
              
            </h1>
            
          </div>
        </div>

        {/* Right: Phone + Address */}
        <div className="vaduaplu-header-right">
        

<span className="vaduaplu-address">
🌐 Visit our site: <a className = "a-links-vaduaplu" href="https://www.gomezthreeproductions.com" target="_blank" rel="noopener noreferrer">gomezthreeproductions.com</a>
📞 Contact: <a className = "a-links-vaduaplu" href="tel:+18303540963">(830) 354-0963</a><br />
✉️ Email: <a className = "a-links-vaduaplu" href="mailto:gomezthreeproduction@outlook.com">gomezthreeproduction@outlook.com</a>
  <br/>
  <br/>
  <p className="vaduaplu-text">
    <li>
    🌐 Website: <a className = "a-links-vaduaplu" href="https://g3pro.net" target="_blank" rel="noopener noreferrer">g3pro.net</a><br />
    🧠 Twitch: <a className = "a-links-vaduaplu" href="https://www.twitch.tv/g3gaming91" target="_blank" rel="noopener noreferrer">twitch.tv/g3gaming91</a><br />
  📸 Instagram: <a className = "a-links-vaduaplu" href="https://instagram.com/gomezthreepro" target="_blank" rel="noopener noreferrer">@gomezthreepro</a><br />
    📘 Facebook: <a className = "a-links-vaduaplu" href="https://www.facebook.com/gomezthreepro/" target="_blank" rel="noopener noreferrer">G3 Productions on Facebook</a><br />
    ▶️ YouTube: <a className = "a-links-vaduaplu" href="https://www.youtube.com/@G3Productions91" target="_blank" rel="noopener noreferrer">@G3Productions91</a>
  </li>
  </p>
   
  
</span>

        </div>
      </header>

    
      {/* Single Top Box combining Quick Menu & Deals */}
      <div className="vaduaplu-top-box">
        {/* Deals Section */}
        <div className="vaduaplu-top-section">
          <h2 className="vaduaplu-heading">Get Deals</h2>
          {/* Flashing Text */}
          <p className={`vaduaplu-deals-text ${fade ? "fade-in" : "fade-out"}`}>
            {deals[dealIndex]}
          </p>

          {/* Static Image below the deals text */}
          <img
            src={adGoOurHub}
            alt="GoOurHub Ad"
            className="vaduaplu-ad-image"
          />
        </div>

        {/* Quick Menu Section */}
        <div className="vaduaplu-top-section">
          <h2 className="vaduaplu-heading">Our Highlights</h2>
          <div className="vaduaplu-accordion">
            <div className="vaduaplu-accordion-item">
              <input type="checkbox" id="service1" className="hidden-checkbox"defaultChecked />
              <label htmlFor="service1" className="vaduaplu-label" align = "center">
              Our Highlights
              </label>
              <div className="vaduaplu-accordion-content">
              <ul className="vaduaplu-list">
  <li className="vaduaplu-list-item">
    🎥 <strong>G3 Productions</strong> – Led by Victor Manuel, offering photography, videography, shopping service, and gaming content creation.
  </li>
<br/>
<br/>

  <li className="vaduaplu-list-item">
    🕹️ Whether you need professional event coverage or want to catch the latest gaming reviews and Twitch streams   we’ve got you covered.
  </li>
  <br/>
  <br/>

  <li className="vaduaplu-list-item">
    📞 Contact: <a className = "a-links-vaduaplu" href="tel:+18303540963">(830) 354-0963</a><br />
    ✉️ Email: <a className = "a-links-vaduaplu" href="mailto:victor.gomez@g3pro.net">victor.gomez@g3pro.net</a>
  </li>
  <br/>

</ul>






              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content / Gallery */}
      <main className="vaduaplu-main-content">
        <h2 className="vaduaplu-heading">Gallery</h2>
        <div className="vaduaplu-gallery">
          {[...Array(6)].map((_, index) => (
            <img
              key={index}
              src={images[index % images.length]}
              alt={`Work Sample ${index + 1}`}
              className="vaduaplu-image"
            />
          ))}
        </div>
      </main>

      {/* Extra Text Section */}
      <div className="vaduaplu-extra-text">
        <p className="vaduaplu-extra-text-p">
       G3 Productions    </p>
      </div>
    </div>
  );
}

export default  G3Production
  ;
